export const lightModeAssets = {
    logo: require("./newIcons/light/chatai-logo.svg").default,
    sidebar: require('./newIcons/light/sidebar.svg').default,
    plus: require('./newIcons/light/plus.svg').default,
    question: require('./newIcons/light/Question.svg').default,
    pencil: require('./newIcons/light/Pencil.svg').default,
    lightBlub: require('./newIcons/light/Lightbulb.svg').default,
    globe: require('./newIcons/light/Globe.svg').default,
}